module.exports = __webpack_public_path__ + "static/media/yellow-star-unrated.512fa73e.svg";